import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import Box from "ui/atom/Box";
import Button from "ui/base/Button";


export default function Subscribe({ title, description, action, to, click, align = "center" }) {
	const theme = useTheme();
	const style = {
		root: {
			textAlign: "center",
			maxWidth: "sm",
			mt: theme.spacing(10),
			mx: "auto"
		},
		title: {
			fontSize: { xs: 32, sm: 44 }
		},
		description: {
			whiteSpace: "break-spaces",
			textAlign: align
		},
		button: {
			mx: "auto"
		}
	};

	return (
		<Box.Column gap={4} sx={style.root}>
			<Box.Column gap={1}>
				<Typography variant="h1" sx={style.title}>{title}</Typography>
				<Typography variant="body1" sx={style.description}>{description}</Typography>
			</Box.Column>
			{click && <Button variant="contained" color="tertiary" onClick={click} sx={style.button}>{action}</Button>}
			{to && <Button.Link to={to} variant="contained" color="tertiary" sx={style.button}>{action}</Button.Link>}
		</Box.Column>
	);
};